<template>
  <div>
    <div class="flex flex-col w-full side-att-in">
      <div class="extra-area overflow-scroll">
        <div
          class="flex flex-col space-y-2 pt-0 px-1 "
          v-for="(attr, i) in attributes"
          :key="i"
        >
          <div class="px-8">
            <div class="relative">
              <div
                aria-hidden="true"
                class="absolute inset-0 flex items-center"
              >
                <div class="w-full border-t border-gray-200 border-dashed"></div>
              </div>
              <div class="relative flex justify-start">
                <span class="pr-2 bg-white text-sm text-primary-color nunito-bold capitalize">
                  {{ attr.name }}
                </span>
              </div>
            </div>
            <div
              class="flex flex-col mt-4"
              v-if="attr.is_multi_select"
            >
              <div
                class="cursor-pointer relative flex aic jcs attr-items smooth"
                v-for="(item, i) in attr.items"
                :key="i"
                @click="selectAttr(item)"
                :class="
                  selectedAttributes.includes(item)
                    ? 'attr-items-selected'
                    : 'attr-items'
                "
              >
                <img
                  :src="item.image ? storageUrl + '' + item.image : '/dish.webp'"
                  alt=""
                  class="mb-2 rounded-3xl w-40p h-40p object-cover"
                />
                <div class="flex flex-grow px-6 aic jcb">
                  <span class="fs-13 capitalize">{{ item.name }} </span>
                    <span class="fs-13 text-gray-600 nunito-semibold">{{ currency }} {{ item.pivot.price }}</span>
                </div>
                <div 
                  class="rounded-md w-30p h-30p flex aic jcc fs-20"
                    :class="
                      selectedAttributes.includes(item)
                        ? 'bg-white'
                        : 'bg-gray-100'
                    "
                  >
                  <i 
                    class="fa fa-check"
                    :class="
                      selectedAttributes.includes(item)
                        ? 'block text-green'
                        : 'hidden'
                    "
                    ></i>
                </div>
              </div>
            </div>
            <div
              class="flex flex-col mt-4"
              v-else
            >
              <div
                class="cursor-pointer relative flex aic jcs attr-items smooth"
                v-for="(item, i) in attr.items"
                :key="i"
                @click="selectAttributeItemNotMulti(item)"
                :class="
                  selectedAttributes.includes(item)
                    ? 'attr-items-selected'
                    : 'attr-items'
                "
              >
                <img
                  :src="item.image ? storageUrl + '' + item.image : '/dish.webp'"
                  alt=""
                  class="mb-2 rounded-3xl w-40p h-40p object-cover"
                />
                <div class="flex flex-grow px-6 aic jcb">
                  <span class="fs-13
                   capitalize">{{ item.name }} </span>
                    <span class="fs-12 text-gray-600 nunito-semibold">{{ currency }} {{ item.pivot.price }}</span>
                </div>
                <div 
                  class="rounded-md w-30p h-30p flex aic jcc fs-20"
                    :class="
                      selectedAttributes.includes(item)
                        ? 'bg-white'
                        : 'bg-gray-100'
                    "
                  >
                  <i 
                    class="fa fa-check"
                    :class="
                      selectedAttributes.includes(item)
                        ? 'block text-green'
                        : 'hidden'
                    "
                    ></i>
                </div>
              </div>
            </div>
          </div>
          <div class="extra-area-overlay"></div>
        </div>
      </div>
    </div>
    <div class="flex aic jcb mt-auto bg-secondary-dark att-btn absolute bottom-0 left-0 w-full">
      <div class="flex flex-col ais jcb text-left px-6 nunito-bold">
        <span class="text-primary-dark text-lg">{{ currency }} <span class="nunito-extrabold">{{ productTotalPrice }}</span></span>
        <div class="flex aic space-x-1 text-right">
          <span class="text-gray-800 text-xs">{{ product.price }}</span>
          <span>+</span>
          <span class="text-white text-xs whitespace-nowrap">{{ atrributesTotalPrice }}</span>
        </div>
      </div>
      <button
        type="button"
        @click="addToBasket"
        class="inline-flex jcc aic nunito-semibold tracking-wide relative w-130p h-full bg-primary-dark text-white"
      >
        {{ $t('Add') }}
      </button>
    </div>

  </div>
</template>

<script>

export default {
  props: ["attributes", "currency", "storageUrl", "product"],
  data() {
    return {
      selectedAttributes: [],
      typeArray: [],
      attributeItemsNotMulti: [],
    };
  },
  methods: {
    removeElement(array, elem) {
      var index = array.indexOf(elem);
      if (index > -1) {
        array.splice(index, 1);
      }
    },
    selectAttributeItemNotMulti(item, type) {
      this.typeArray.push(type);
      if (this.attributeItemsNotMulti.find((f) => f.type == type)) {
        if (this.selectedAttributes.find((f) => f.id == item.id)) {
          this.selectedAttributes = this.selectedAttributes.filter(
            (f) => f.id != item.id
          );
        } else {
          this.attributeItemsNotMulti.find((f) => {
            if (f.type == type) {
              this.removeElement(this.attributeItemsNotMulti, f);
              this.removeElement(this.selectedAttributes, f.item);

              this.attributeItemsNotMulti.push({ item, type });
              this.selectedAttributes.push(item);
            }
          });
        }
      } else {
        this.attributeItemsNotMulti.push({ item, type });
        this.selectedAttributes.push(item);
      }
    },
    selectAttr(item) {
      if (!this.selectedAttributes.includes(item))
        this.selectedAttributes.push(item);
      else
        this.selectedAttributes.splice(
          this.selectedAttributes.indexOf(item),
          1
        );
    },
    addToBasket() {
      this.$store
        .dispatch("order/addToBasket", {
          productId: this.product.id,
          restaurantId: this.restaurantId,
          attributeItems: this.selectedAttributes.map((m) => {
            return m.id;
          }),
        })
        .then(() => {
          this.$emit("close");
          this.selectedAttributes = [];
        });

    },
  },
  computed: {
    restaurantId() {
      return process.env.VUE_APP_RESTAURANT_ID;
    },
    productTotalPrice() {
      const total = this.selectedAttributes
        .map((m) => {
          return Number(m.pivot.price);
        })
        .reduce(function (a, b) {
          return a + b;
        }, Number(this.product.price))
        .toFixed(2);
      return total;
    },
    atrributesTotalPrice() {
      const total = this.selectedAttributes
        .map((m) => {
          return Number(m.pivot.price);
        })
        .reduce(function (a, b) {
          return a + b;
        }, 0)
        .toFixed(2);
      return total;
    },
  },
};
</script>

<style></style>
